module.exports = __webpack_public_path__ + "static/media/metawheel4.03df0e5c.png";